import { getClientDetail, messageLogin } from "@/api/client";
import { getAdminUserDetail } from "@/api/trader";
import router, { asyncRouteMap } from "@/router";
import { appLogin, appAuto } from "@/api/app";

import {
  getToken,
  getUID,
  setName,
  setToken,
  setUID,
  setType,
  getType,
  setButtons
} from "../../utils/auth";

const store = {
  state: {
    token: "",
    name: "",
    uid: "",
    passInit: 1,
    userInfo: {}
  },
  getters: {
    uid(state) {
      return state.uid;
    },
    name(state) {
      return state.name;
    },
    token(state) {
      return state.token;
    }
  },
  // methods 同步 $store.commit('SET_NAME')
  mutations: {
    SET_NAME(state, name) {
      state.name = name;
    },
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_UID(state, uid) {
      state.uid = uid;
    },
    SET_PASSINIT(state, init) {
      state.passInit = init;
    },
    saveUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    }
  },
  // methods 异步 $store.dispatch('SET_NAME')
  actions: {
    restoreUser({ commit, dispatch }) {
      const token = getToken();
      commit("SET_TOKEN", token);
      commit("SET_UID", getUID());
      if (token) {
        router.addRoutes(asyncRouteMap);
        if (window.location.pathname === "/zlbLogin/index") {
          commit("SET_TOKEN", "");
          commit("SET_UID", "");
          commit("SET_PASSINIT", 0);

          setToken("");
          setUID("");
          setType("");
          setButtons("");
        } else {
          dispatch("fetchUserInfo");
        }
      }
    },

    fetchUserInfo({ commit }) {
      if (getType() === "user") {
        getClientDetail().then(res => {
          commit("saveUserInfo", res);
        });
      } else {
        getAdminUserDetail().then(res => {
          commit("saveUserInfo", res);
        });
      }

      // if (getType() === 1) {
      //   getClientDetail().then(res => {
      //     commit("saveUserInfo", res);
      //   });
      // } else {
      //   getAdminUserDetail().then(res => {
      //     commit("saveUserInfo", res);
      //   });
      // }
    },

    /**
     * 登录
     * @param user 登录的用户信息
     * @param commit
     * @return {Promise} 用户信息
     */
    async login({ dispatch }, user) {
      const userInfo = await messageLogin(user);
      if (userInfo.user_id) {
        return dispatch("commonLogin", userInfo);
      } else {
        return userInfo;
      }
    },

    async commonLogin({ commit, dispatch }, userInfo) {
      let token = userInfo.token_type + " " + userInfo.access_token;
      commit("SET_TOKEN", token);
      commit("SET_UID", userInfo.user_id);
      setToken(token);
      setUID(userInfo.user_id);
      setType(userInfo.user_type || "user");
      // // commit("SET_TOKEN", userInfo.token);
      // // commit("SET_UID", userInfo.id);
      // setToken(userInfo.token);
      // setUID(userInfo.id);
      // setType(userInfo.type || 1);
      //
      dispatch("fetchUserInfo");

      router.addRoutes(asyncRouteMap);
      return userInfo;
    },

    async applogin({ dispatch }, user) {
      const userInfo = await appLogin(user);
      return dispatch("commonAppLogin", userInfo);
    },

    async commonAppLogin({ commit, dispatch }, userInfo) {
      commit("SET_TOKEN", userInfo.token);
      commit("SET_UID", userInfo.id);

      setToken(userInfo.token);
      setUID(userInfo.id);
      setType(userInfo.type || 1);

      dispatch("fetchUserInfo");
      router.addRoutes(asyncRouteMap);
      return userInfo;
    },

    async appAutoLogin({ dispatch }, user) {
      const userInfo = await appAuto(user);
      return dispatch("commonAppAutoLogin", userInfo);
    },

    async commonAppAutoLogin({ commit, dispatch }, userInfo) {
      commit("SET_TOKEN", userInfo.token);
      commit("SET_UID", userInfo.userId);

      setToken(userInfo.token);
      setUID(userInfo.userId);
      setType(userInfo.type || 1);

      dispatch("fetchUserInfo");
      router.addRoutes(asyncRouteMap);
      return userInfo;
    },

    /**
     * 登出 清空所有用户资料
     */
    logout({ commit }) {
      commit("SET_TOKEN", "");
      commit("SET_UID", "");
      commit("SET_PASSINIT", 0);

      setToken("");
      setUID("");
      setType("");
      setButtons("");
    },
    FedLogOut({ commit }) {
      commit("SET_NAME", "");
      commit("SET_TOKEN", "");
      commit("SET_UID", "");
      commit("SET_UID", "");

      setName("");
      setToken("");
      setUID("");
      setType("");

      return Promise.resolve();
    }
  }
};

export default store;
